import { useTranslation } from "react-i18next";

export function useCommunitiesPageMeta() {
    const { t } = useTranslation();

    const metaTitle = t("communitiesPage.meta.title");
    const metaDescription = t("communitiesPage.meta.description");
    const title = t("communitiesPage.meta.h1");
    const seoText = t("communitiesPage.meta.seo");

    return { title, metaTitle, seoText, metaDescription };
}
